import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const totalSharesConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.youtube.total_shares',
    id: 'shares',
    icon: {
        name: 'share',
        style: colors.aquablue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: 'kpi.youtube.tooltip_total_shares',
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader
};
